module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./NoticeView.js"));
	}, "RegisterNoticeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RegisterNoticeView!./src/pages/Shop/Member/Agreements/Notice/NoticeView.js
// module id = 942
// module chunks = 438